import { render } from "./AccountActivationModal.vue?vue&type=template&id=4696a3f2&ts=true"
import script from "./AccountActivationModal.vue?vue&type=script&lang=ts"
export * from "./AccountActivationModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__